import { inject } from '@angular/core';
import { UserState, initialState } from './user.model';
import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';
import { AuthenticationService } from 'src/app/auth/services';

export const UserStore = signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withMethods(({ user = inject(AuthenticationService), ...store }) => ({
        setUser(users: UserState) {
            patchState(store, { 
                user: users.user,
                token: users.token,
                isLogged: true,
             });
        },
        logout(){
            patchState(store, initialState)
        },
        changeStatus(status: boolean) {
            patchState(store, {isLoading:status});
        }
    })),
);